// extracted by mini-css-extract-plugin
export default {"body":"styles_body__roIhm","tab":"styles_tab__eZoDY","activeTab":"styles_activeTab__sfBvW","tabs":"styles_tabs__C60vr"};